import { viewCarrierStructure } from '@/constants/carriers-constants';

const basicCost = viewCarrierStructure.basicCost;
const moreInfo = viewCarrierStructure.moreInfo;

export const carriersJa = {
  [basicCost.section1.part1.chModel]: 'シャーシモデル',
  [basicCost.section1.part1.chNo]: 'シャーシ番号',
  [basicCost.section1.part1.make]: 'メーカー',
  [basicCost.section1.part1.model]: 'モデル',
  [basicCost.section1.part1.stock]: '在庫',
  [basicCost.section1.part1.fuelType]: '燃料タイプ',
  [basicCost.section1.part1.modelCode]: 'モデルコード',
  [basicCost.section1.part1.category]: 'カテゴリ',
  [basicCost.section1.part1.exportCategory]: 'エクスポートカテゴリ',
  [basicCost.section1.part1.engineYearMonth]: '月／年',

  [basicCost.section1.part2.extColor]: '色',
  [basicCost.section1.part2.transmission]: 'トランスミッション',
  [basicCost.section1.part2.traction]: '駆動力',
  [basicCost.section1.part2.drive]: 'ドライブ方式',
  [basicCost.section1.part2.powerKw]: '出力(KW)',
  [basicCost.section1.part2.powerCc]: '排気量(CC)',
  [basicCost.section1.part2.doors]: 'ドア数',
  [basicCost.section1.part2.capacity]: '最大負荷量',
  [basicCost.section1.part2.seating]: '座席数',
  [basicCost.section1.part2.interiorColour]: '内装色',
  [basicCost.section1.part2.condition]: '状態',
  [basicCost.section1.part2.driveKM]: '走行距離',
  [basicCost.section1.part2.engineType]: 'エンジンタイプ',
  [basicCost.section1.part2.engineNo]: 'エンジン番号',
  [basicCost.section1.part2.ichijiMacho]: '一次機械',

  [basicCost.section1.part3.auctionBy]: 'オークション主催者',
  [basicCost.section1.part3.purchasedDate]: '購入日',
  [basicCost.section1.part3.lotNo]: 'ロット番号',
  [basicCost.section1.part3.runNo]: '走行番号',
  [basicCost.section1.part3.bidder]: '入札者',
  [basicCost.section1.part3.auctionDate]: 'オークション日',
  [basicCost.section1.part3.salesPerson]: '販売担当者',
  [basicCost.section1.part3.location]: '場所',
  [basicCost.section1.part3.auctionGrade]: 'オークショングレード',
  [basicCost.section1.part3.dealer]: 'ディーラー',
  [basicCost.section1.part3.seller]: '販売者',

  [basicCost.section2.fobPrice]: 'FOB価格',
  [basicCost.section2.totalCost]: '総費用',
  [basicCost.section2.salePercent]: '販売率',
  [basicCost.section2.saleResult]: '販売結果',
  [basicCost.section2.saleAmt]: '販売金額',
  [basicCost.section2.basicCost.buyPrice]: '購入価格',
  [basicCost.section2.basicCost.aucFee]: 'オークション手数料',
  [basicCost.section2.basicCost.riksoFeeTax]: '陸送費税',
  [basicCost.section2.basicCost.recycleFee]: 'リサイクル料金',
  [basicCost.section2.basicCost.buyPriceTax]: '購入価格税',
  [basicCost.section2.basicCost.aucFeeTax]: 'オークション手数料税',
  [basicCost.section2.basicCost.riksoFee]: '陸送費',
  [basicCost.section2.basicCost.jidoushaZei]: '自動車税',
  [basicCost.section2.basicCost.inspectionFee]: '検査費用',
  [basicCost.section2.basicCost.inspectionFeeTax]: '検査費用税',

  [basicCost.section2.saleCost.aucListFee]: 'オークション出品料',
  [basicCost.section2.saleCost.aucSellingFee]: 'オークション成約料',
  [basicCost.section2.saleCost.forwardingCost]: 'フォワーディング合計',
  [basicCost.section2.saleCost.freightFee]: '運賃',
  [basicCost.section2.saleCost.insuranceFee]: '保険料',
  [basicCost.section2.saleCost.portRemovalFee]: '港引取料',
  [basicCost.section2.saleCost.radioActive]: '放射能検査',
  [basicCost.section2.saleCost.storageFee]: '保管料',

  [basicCost.section2.additionalCost.shaken]: '車検',
  [basicCost.section2.additionalCost.shakenReceived]: '車検受領',
  [basicCost.section2.additionalCost.claimCost]: 'クレーム費用',
  [basicCost.section2.additionalCost.parkingPenalty]: '駐車違反金',
  [basicCost.section2.additionalCost.misc]: '雑費',

  [basicCost.section2.creditCost.claimCredit]: '請求クレジット',
  [basicCost.section2.creditCost.discCredit]: '割引クレジット',
  [basicCost.section2.creditCost.recyleFeeRefund]: 'リサイクル料金返金',
  [basicCost.section2.creditCost.jidoushaZeinRefund]: '自動車税返金',
  [basicCost.section2.creditCost.lateDocCredit]: '書類遅延クレジット',

  [moreInfo.goods.action]: 'アクション',
  [moreInfo.goods.description]: '説明',
  [moreInfo.goods.received]: '受領済み',
  [moreInfo.goods.done]: '完了',
  [moreInfo.goods.courier]: '宅配業者',
  [moreInfo.goods.awb]: '運送状 (AWB)',
  [moreInfo.bodyDimensions.carArea]: '面積 (m³)',
  [moreInfo.bodyDimensions.carHeight]: '高さ (cm)',
  [moreInfo.bodyDimensions.carLength]: '長さ (cm)',
  [moreInfo.bodyDimensions.carWidth]: '幅 (cm)',
  [moreInfo.bodyDimensions.carryingWeight]: '積載重量 (kg)',
  [moreInfo.bodyDimensions.grossWeight]: '総重量 (kg)',
  [moreInfo.bodyDimensions.netWeight]: '国内重量 (kg)',
  [moreInfo.bodyDimensions.n1]: 'N1',
  [moreInfo.bodyDimensions.n2]: 'N2',
  [moreInfo.bodyDimensions.n3]: 'N3',
  [moreInfo.bodyDimensions.n4]: 'N4',

  [moreInfo.properties.ac]: 'エアコン',
  [moreInfo.properties.abs]: 'ABS',
  [moreInfo.properties.autoWindow]: '自動ウィンドウ',
  [moreInfo.properties.backCam]: 'バックカメラ',
  [moreInfo.properties.bluetooth]: 'ブルートゥース',
  [moreInfo.properties.bodyKit]: 'ボディキット',
  [moreInfo.properties.bothSidePowerSlideDoor]: '両側電動スライドドア',
  [moreInfo.properties.camera360]: '360度カメラ',
  [moreInfo.properties.centralLock]: '集中ドアロック',
  [moreInfo.properties.cornerSensor]: 'コーナーセンサー',
  [moreInfo.properties.displayAudio]: 'ディスプレイオーディオ',
  [moreInfo.properties.fogLights]: 'フォグライト',
  [moreInfo.properties.leatherSeats]: 'レザーシート',
  [moreInfo.properties.led]: 'LED',
  [moreInfo.properties.navigation]: 'ナビゲーション',
  [moreInfo.properties.oneOwner]: 'ワンオーナー',
  [moreInfo.properties.oneSidePowerSlideDoor]: '片側電動スライドドア',
  [moreInfo.properties.panoramaRoof]: 'パノラマルーフ',
  [moreInfo.properties.powerMirror]: '電動ミラー',
  [moreInfo.properties.powerSeats]: 'パワーシート',
  [moreInfo.properties.powerSlideDoor]: '電動スライドドア',
  [moreInfo.properties.powerSteering]: 'パワーステアリング',
  [moreInfo.properties.powerWindows]: 'パワーウィンドウ',
  [moreInfo.properties.rearSpoiler]: 'リアスポイラー',
  [moreInfo.properties.roofRail]: 'ルーフレール',
  [moreInfo.properties.srsAirbags]: 'SRSエアバッグ',
  [moreInfo.properties.sunRoof]: 'サンルーフ',
  [moreInfo.properties.tv]: 'テレビ',
} as const;
